import React from "react";
import { Field, Form } from "formik";
import { useLocalizeStateValue } from "../../../languages/Localize";
import styled from "styled-components";
import Input from "../../../components/inputs/Input";

const StyledForm = styled(Form)``;

const VerificationForm = props => {
    const { strings } = useLocalizeStateValue();
    const {
        values: { captcha = "" },
        handleChange,
        submitCount,
        handleBlur,
        isValid,
        setFieldTouched,
        onValidityChange
    } = props;

    const handleFormSubmit = e => {
        e.preventDefault();
    };

    const onChangeHandler = e => {
        handleChange(e);
        setFieldTouched(e.target.name, true, false);
    };

    const onBlurHandler = e => {
        handleBlur(e);
        props.onFormChange({ [e.target.name]: e.target.value });
    };

    /* eslint-disable */
    React.useEffect(() => {
        onValidityChange(isValid);
    }, [isValid]);
    /* eslint-enable */

    return (
        <StyledForm className="form-container" onSubmit={handleFormSubmit}>
            <Field name="captcha">
                {props => (
                    <Input
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                        label={strings.register.verificationForm.captcha}
                        value={captcha}
                        submitCount={submitCount}
                        hasFeedback
                        {...props}
                    />
                )}
            </Field>
        </StyledForm>
    );
};

export default VerificationForm;
